import type { LetterDeliveryDecisionDraft, LetterDeliveryDecisionRow } from "../../../contract"
import { validateLetterDeliveryDecision } from "../../../_shared/_logic/02-decide-appointment-letter-delivery-payload"

export const summarizeLetterDeliveryDecisions = (
  rows: LetterDeliveryDecisionRow[],
  draftFor: (row: LetterDeliveryDecisionRow) => LetterDeliveryDecisionDraft,
  automaticLetterDeliveryAllowed: boolean,
  organizationReason: string | null = null,
) => {
  let automatic = 0
  let manual = 0
  let blocked = 0
  const reasons = new Set<string>()
  for (const row of rows) {
    const draft = draftFor(row)

    if (draft.deliveryMode === "automatic") automatic += 1

    if (draft.deliveryMode === "manual") manual += 1

    const error = validateLetterDeliveryDecision(
      row,
      draft,
      automaticLetterDeliveryAllowed,
      organizationReason,
    )

    if (error) {
      blocked += 1
      reasons.add(error)
    }
  }

  return { automatic, manual, blocked, reasons: [...reasons] }
}
